document.addEventListener('DOMContentLoaded', () => {
  const startAnimation = (entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return
      }
      if (entry.target.classList.contains('visible-animated')) {
        return
      }
      entry.target.classList.add('visible-animated', entry.isIntersecting)
    })
  }

  const observer = new IntersectionObserver(startAnimation)
  const options = { root: null, rootMargin: '0px', threshold: 1 }
  const staticHeaders = document.querySelectorAll('.js-static-header')
  staticHeaders.forEach((el) => {
    observer.observe(el, options)
  })
})
